var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#143C67;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.7,310.8h-26.6c-13.6,0-24.7-11-24.7-24.7v-54.4c0-13.6,11-24.7,24.7-24.7H223c13.6,0,24.7,11,24.7,24.7 v54.4c0,13.6-11,24.7-24.7,24.7h-37.5l57.1,90.1h58.5l-32.7-51.6c16.9-10.9,28.6-29.4,28.6-50.8v-79.2c0-34-29.8-61-63.3-61H127.4 c-33.6,0-63.3,27-63.3,61v79.2c0,34.1,29.8,61,63.3,61h68.2L164.7,310.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474,359.6h-86.3c-33.5,0-63.3-27-63.3-61V158.3h49.4v127.8c0,13.6,11,24.7,24.7,24.7H474V359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-63.6,207.1H36.9v-48.8h-108c-30.3,0-55,24.9-54.9,57.8v9.4c-0.1,33,24.6,57.8,54.9,57.8h51.7 c7.8,0,14.1,5.9,14.1,13.6v0.2h0.1c0,7.7-6.3,13.6-14.1,13.6h-97.2v48.8h104.7c30.3,0,55-24.9,54.9-57.8v-9.4 c0.1-33-24.7-57.8-55-57.8h-51.7c-7.8,0-14.1-5.9-14.1-13.6v-0.2C-77.7,213-71.4,207.1-63.6,207.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.151260d4307c57f0e49f1182deb41ed1.svg";
export { ForwardRef as ReactComponent };